'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    $('#login-form-password').click(function() {
        $('#login-form-password').focus();
    });

    processInclude(require('./login/login'));
});
